"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRegExps = exports.EmlFormatId = exports.CloudStockAttachIdReg = exports.AttachIdReg = exports.TemporaryAttachIdReg = exports.CloudAttachIdReg = exports.TemporaryMessageIdReg = exports.CommonMessageIdReg = exports.AttachPathReg = exports.URLPartsReg = void 0;
/** Регулярка для проверки на формат урла */
exports.URLPartsReg = '^https:\\/?\\/?[^:/\\s]+\\/attaches\\/[\\w\\-.]+[^#?\\s]+.*?$';
/** Регулярка, разделяющая айди письма и аттача */
exports.AttachPathReg = '^(\\w+);(.*)';
/** Регулярка айди письма */
exports.CommonMessageIdReg = '^\\d{20}';
/** Регулярка айди письма для временного аттача */
exports.TemporaryMessageIdReg = '^\\w{32}$';
/** Регулярки айди облачного аттача */
exports.CloudAttachIdReg = '^\\/public\\/.*$';
/** Регулярка айди временного аттача */
exports.TemporaryAttachIdReg = '^\\w{16}';
/** Регулярка айди обычного аттача */
exports.AttachIdReg = '^\\w+;\\w+';
/** Регулярка айди стокового аттача */
exports.CloudStockAttachIdReg = '^\\w+:\\w+';
/** Регулярка для определения айди из eml письма */
exports.EmlFormatId = '^([0-9;]+);([0-9]+;[0-9]+;[0-9]+;[0-9]+)';
exports.defaultRegExps = {
    attachesRegExps: {
        cloudAttachIdReg: exports.CloudAttachIdReg,
        temporaryAttachIdReg: exports.TemporaryAttachIdReg,
        attachIdReg: exports.AttachIdReg,
        cloudStockAttachIdReg: exports.CloudStockAttachIdReg,
    },
    messageIdsRegExps: {
        commonMessageIdReg: exports.CommonMessageIdReg,
        temporaryMessageIdReg: exports.TemporaryMessageIdReg,
    },
    urlPartsReg: exports.URLPartsReg,
    attachPathReg: exports.AttachPathReg,
};
//# sourceMappingURL=regexps.js.map